import { Input } from 'antd';
import Validator from '../../../../../../common/hoc/withValidation/withValidation';

export const { TextArea } = Input;

export const OfferIs = ({ ...props }) =>
  Validator(Input, props, {
    value: props.val ? props.val : null,
    classes: props.classes,
    name: 'offerIs',
    rules: [],
  });

export const RequestId = ({ ...props }) =>
  Validator(Input, props, {
    value: props.val ? props.val : null,
    classes: props.classes,
    name: 'requestId',
    rules: [],
  });

export const DateBirth = ({ ...props }) =>
  Validator(Input, props, {
    value: props.val ? props.val : null,
    classes: props.classes,
    name: 'dateBirth',
    rules: [],
  });

export const Name = ({ ...props }) =>
  Validator(Input, props, {
    value: props.val ? props.val : null,
    classes: props.classes,
    name: 'name',
    rules: [],
  });

export const LastName = ({ ...props }) =>
  Validator(Input, props, {
    value: props.val ? props.val : null,
    classes: props.classes,
    name: 'lastname',
    rules: [],
  });

export const Patronymic = ({ ...props }) =>
  Validator(Input, props, {
    value: props.val ? props.val : null,
    classes: props.classes,
    name: 'patronymic',
    rules: [],
  });

export const SubjectId = ({ ...props }) =>
  Validator(Input, props, {
    value: props.val ? props.val : null,
    // label: 'Субъект заказчика',
    classes: props.classes,
    name: 'subjectId',
    rules: [],
  });

export const Customer = ({ ...props }) =>
  Validator(Input, props, {
    value: props.val ? props.val : null,
    // label: 'Заказчик',
    classes: props.classes,
    name: 'customer',
    rules: [],
  });

export const Inn = ({ ...props }) =>
  Validator(Input, props, {
    value: props.val ? props.val : null,
    // label: 'ИНН',
    classes: props.classes,
    name: 'inn',
    rules: [],
  });

export const Ogrn = ({ ...props }) =>
  Validator(Input, props, {
    value: props.val ? props.val : null,
    // label: 'ИНН',
    classes: props.classes,
    name: 'ogrn',
    rules: [],
  });

export const Ogrnip = ({ ...props }) =>
  Validator(Input, props, {
    value: props.val ? props.val : null,
    // label: 'ИНН',
    classes: props.classes,
    name: 'ogrnip',
    rules: [],
  });

export const Kpp = ({ ...props }) =>
  Validator(Input, props, {
    value: props.val ? props.val : null,
    // label: 'ИНН',
    classes: props.classes,
    name: 'kpp',
    rules: [],
  });

export const Eio = ({ ...props }) =>
  Validator(Input, props, {
    value: props.val ? props.val : null,
    // label: 'ЕИО',
    classes: props.classes,
    name: 'eio',
    rules: [],
  });

export const PhoneCode = ({ ...props }) =>
  Validator(Input, props, {
    value: props.val ? props.val : null,
    classes: props.classes,
    name: 'code',
    rules: [],
  });

export const PhoneNumber = ({ ...props }) =>
  Validator(Input, props, {
    value: props.val ? props.val : null,
    classes: props.classes,
    name: 'phone',
    mask: '(###) ###-##-##',
    rules: [],
  });

export const Email = ({ ...props }) =>
  Validator(Input, props, {
    value: props.val ? props.val : 'Не указан',
    // label: 'Email',
    classes: props.classes,
    name: 'email',
    rules: [],
  });

export const Website = ({ ...props }) =>
  Validator(Input, props, {
    value: props.val ? props.val : null,
    // label: 'Сайт',
    classes: props.classes,
    name: 'website',
    rules: [],
  });

export const ServiceType = ({ ...props }) =>
  Validator(Input, props, {
    value: props.val ? props.val : null,
    // label: 'Вид транспортной услуги',
    classes: props.classes,
    name: 'serviceType',
    rules: [],
  });

export const PassengersCount = ({ ...props }) =>
  Validator(Input, props, {
    value: props.val ? props.val : null,
    // label: 'Количество пассажиров',
    classes: props.classes,
    name: 'passengersCount',
    rules: [],
  });

export const KidsCount = ({ ...props }) =>
  Validator(Input, props, {
    value: props.val ? props.val : null,
    // label: 'Количество пассажиров',
    classes: props.classes,
    name: 'kidsCount',
    rules: [],
  });

export const AccompCount = ({ ...props }) =>
  Validator(Input, props, {
    value: props.val ? props.val : null,
    // label: 'Количество пассажиров',
    classes: props.classes,
    name: 'accompCount',
    rules: [],
  });

export const WorkersCount = ({ ...props }) =>
  Validator(Input, props, {
    value: props.val ? props.val : null,
    classes: props.classes,
    name: 'workersCount',
    rules: [],
  });

export const MedWorkersCount = ({ ...props }) =>
  Validator(Input, props, {
    value: props.val ? props.val : null,
    classes: props.classes,
    name: 'medWorkersCount',
    rules: [],
  });

export const StartPoint = ({ ...props }) =>
  Validator(Input, props, {
    value: props.val ? props.val : null,
    // label: 'Количество пассажиров',
    classes: props.classes,
    name: 'beginPoint',
    rules: [],
  });

export const ArrivalDate = ({ ...props }) =>
  Validator(Input, props, {
    value: props.val ? props.val : null,
    classes: props.classes,
    name: 'arrivalDate',
    rules: [],
  });

export const ArrivalTime = ({ ...props }) =>
  Validator(Input, props, {
    value: props.val ? props.val : null,
    classes: props.classes,
    name: 'arrivalTime',
    rules: [],
  });

export const EndPoint = ({ ...props }) =>
  Validator(Input, props, {
    value: props.val ? props.val : null,
    // label: 'Количество пассажиров',
    classes: props.classes,
    name: 'endPoint',
    rules: [],
  });

export const Executor = ({ ...props }) =>
  Validator(Input, props, {
    value: props.val ? props.val : null,
    // label: 'Исполнитель',
    classes: props.classes,
    name: 'executor',
    rules: [],
  });

export const Maintenance = ({ ...props }) =>
  Validator(Input, props, {
    value: props.val ? props.val : null,
    // label: 'Уровень обслуживания',
    classes: props.classes,
    name: 'maintenanceLevels',
    rules: [],
  });

export const UsingTime = ({ ...props }) =>
  Validator(Input, props, {
    value: props.val ? props.val : null,
    classes: props.classes,
    name: 'usingTime',
    rules: [],
  });

export const Comment = ({ ...props }) =>
  Validator(TextArea, props, {
    value: props.val ? props.val : null,
    // label: 'Комментарий',
    classes: props.classes,
    name: 'comment',
    rules: [],
  });

export const MidPointAddress = ({ ...props }) =>
  Validator(Input, props, {
    value: props.val ? props.val : null,
    // label: 'Комментарий',
    classes: props.classes,
    name: 'midPointAddress',
    rules: [],
  });

export const MidPointTime = ({ ...props }) =>
  Validator(Input, props, {
    value: props.val ? props.val : null,
    // label: 'Комментарий',
    classes: props.classes,
    name: 'midPointTime',
    rules: [],
  });

export const UrAddress = ({ ...props }) =>
  Validator(Input, props, {
    value: props.val ? props.val : 'Не указан',
    // label: 'Юридический адрес',
    classes: props.classes,
    name: 'urAddress',
    rules: [],
  });

export const FactAddress = ({ ...props }) =>
  Validator(Input, props, {
    value: props.val ? props.val : null,
    // label: 'Фактический адрес',
    classes: props.classes,
    name: 'factAddress',
    rules: [],
  });

export const DateRegistered = ({ ...props }) =>
  Validator(Input, props, {
    value: props.val ? props.val : 'Не указана',
    // label: 'Дата регистрации',
    classes: props.classes,
    name: 'dateRegistered',
    rules: [],
  });

export const Fio = ({ ...props }) =>
  Validator(Input, props, {
    value: props.val ? props.val : null,
    // label: 'Дата регистрации',
    classes: props.classes,
    name: 'fio',
    rules: [],
  });

export const Status = ({ ...props }) =>
  Validator(Input, props, {
    value: props.val ? props.val : 'Не указан',
    // label: 'Дата регистрации',
    classes: props.classes,
    name: 'status',
    rules: [],
  });

export const RepresentativeFio = ({ ...props }) =>
  Validator(Input, props, {
    value: props.val ? props.val : null,
    classes: props.classes,
    name: 'representativeFio',
    rules: [],
  });

export const BankName = ({ ...props }) =>
  Validator(Input, props, {
    value: props.val ? props.val : 'Не указано',
    classes: props.classes,
    name: 'bankName' + props.index,
    rules: [],
  });

export const Bik = ({ ...props }) =>
  Validator(Input, props, {
    value: props.val ? props.val : null,
    classes: props.classes,
    name: 'bik' + props.index,
    rules: [],
  });

export const Сorrespondent = ({ ...props }) =>
  Validator(Input, props, {
    value: props.val ? props.val : null,
    classes: props.classes,
    name: 'accountCorr' + props.index,
    rules: [],
  });

export const BankAccount = ({ ...props }) =>
  Validator(Input, props, {
    value: props.val ? props.val : null,
    classes: props.classes,
    name: 'bankAccountNum' + props.index,
    rules: [],
  });

export const DocumentSeries = ({ ...props }) =>
  Validator(Input, props, {
    value: props.val ? props.val : null,
    classes: props.classes,
    name: 'documentSeries',
    rules: [],
  });

export const DocumentNumber = ({ ...props }) =>
  Validator(Input, props, {
    value: props.val ? props.val : null,
    classes: props.classes,
    name: 'documentNumber',
    rules: [],
  });
